<template>
  <div class="tickets-container">
    <p class="tickets-container-title">{{ adminText('workflowsAll.tickets_5c622a5', 'Tickets') }}</p>
    <template v-for="(group, groupIndex) in ticketGroups">
      <div v-if="group.tickets.length" :key="group.type" class="tickets-wrapper">
        <p class="ticket-type">{{ workflowLabel(group.title) }}</p>
        <button
          v-for="(ticket, index) in group.tickets"
          :key="index"
          type="button"
          class="ticket"
          :class="isTicketSelected(ticket.id) && 'ticket--selected'"
          :disabled="handleDisableTicketButton(ticket, group.type)"
          :style="isTicketSelected(ticket.id) && group.selectedButtonStyle"
          @click="selectedSeats.length && $emit('handleConnectSeatWithTicket', ticket)"
        >
          <div class="ticket-left">
            <div class="ticket-color" :style="'background: ' + ticket.color" />
            <p class="ticket-name" :style="isTicketSelected(ticket.id) && `color: #FFF !important`">
              {{ workflowLabel(ticket.name) }}
            </p>
            <p class="ticket-count">
              {{ workflowLabel(countPerTicket[ticket.id]) }}
            </p>
          </div>
          <div class="ticket-right">
            <p v-if="!isTicketSelected(ticket.id)" class="ticket-price">
              {{ workflowLabel(Number(ticket.price).toFixed(2)) }}€
            </p>
            <span
              v-if="!handleDisableTicketButton(ticket, group.type)"
              class="material-icons ticket-action-icon"
            >
              {{ workflowLabel(isTicketSelected(ticket.id) ? group.iconSelected : group.iconDefault) }}
            </span>
            <span v-if="isTicketSelected(ticket.id)" class="ticket-connected">
              {{ adminText('workflowsAll.connected_c2f9b7b', 'Connected') }}
            </span>
          </div>
        </button>
      </div>
      <hr v-if="group.tickets.length" :key="`${groupIndex}-hr`" class="hr-style">
    </template>
    <div class="tickets-wrapper">
      <p class="ticket-type">{{ adminText('workflowsAll.additional_c897b99', 'Additional') }}</p>
      <div class="seat-state-wrapper">
        <div
          class="seat-state"
          :style="currSelectedSeatState === 2 && 'border: #0277BD solid 1px; background: white'"
          @click="
            selectedSeats.length &&
              (currSelectedSeatState = 2) &&
              $emit('handleSeatAvailability', SeatState.DISABLED)
          "
        >
          <span class="unavailable-circle" />
          <p class="ticket-name" :style="currSelectedSeatState === 2 && 'color:#0277BD;'">
            {{ adminText('workflowsAll.unavailable_2c9c1f7', 'Unavailable') }}
          </p>
        </div>
        <div class="seat-state" style="cursor: default">
          <span class="booked-sold-circle" />
          <p class="ticket-name">{{ adminText('workflowsAll.booked_sold_e485ebd', 'Booked/Sold') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import moment from 'moment/moment'
import { SeatState, TicketType } from '@/types'
import { countSellableSeats } from '@/utils/floor-plan-quantity'

export default {
  mixins: [WorkflowDisplay],
  name: 'floor-plan-ticket-view',
  props: {
    initRegular: {
      type: Array,
      default: () => [],
    },
    initParter: {
      type: Array,
      default: () => [],
    },
    initTable: {
      type: Array,
      default: () => [],
    },
    selectedTicket: null,
    svgElementType: String,
    selectedSeats: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      regular: this.initRegular,
      parter: this.initParter,
      table: this.initTable,
      SeatState: SeatState,
      currSelectedSeatState: 0,
      countPerTicket: {},
    }
  },
  computed: {
    ticketGroups() {
      return [
        {
          type: 'parter',
          title: 'workflowsAll.parter_tickets_3278588',
          tickets: this.parter,
          selectedButtonStyle: 'border:  #56A4EF solid 1px; background: #0277BD !important',
          iconSelected: 'done_all',
          iconDefault: 'link',
        },
        {
          type: 'regular',
          title: 'workflowsAll.seating_tickets_1a18846',
          tickets: this.regular,
          selectedButtonStyle: 'border: #56A4EF solid 1px; background: #0277BD !important',
          iconSelected: 'done_all',
          iconDefault: 'link',
        },
        {
          type: 'table',
          title: 'workflowsAll.table_tickets_5dcbcfe',
          tickets: this.table,
          selectedButtonStyle: 'border:  #56A4EF solid 1px; background: #0277BD !important',
          iconSelected: 'done_all',
          iconDefault: 'link',
        },
      ]
    },
  },
  mounted() {
    this.setCountPerTicket()
  },
  methods: {
    isTicketSelected(id) {
      return (
        this.selectedTicket &&
        this.selectedTicket.length &&
        this.selectedTicket.find(st => st.id === id)
      )
    },
    setCountPerTicket() {
      const newTicketCount = {}
      for (const type of Object.values(TicketType)) {
        this[type].map(oi => {
          newTicketCount[oi.id] = countSellableSeats(oi.sectionSeats)
        })
      }

      return (this.countPerTicket = newTicketCount)
    },
    resetCurrSelectedSeatState() {
      this.currSelectedSeatState = 0
    },
    handleDisableTicketButton(ticket, ticketType) {
      if (ticketType !== this.svgElementType) {
        return true
      }
      const selectableTickets =
        (this.selectedTicket.length &&
          this[this.svgElementType].filter(
            oi =>
              moment(oi.from).isAfter(this.selectedTicket[0].to) ||
              moment(oi.to).isBefore(this.selectedTicket[0].from),
          )) ||
        []

      return (
        !this.selectedSeats.length ||
        (this.selectedTicket.length === 2 &&
          !this.selectedTicket.find(st => st.id.includes(ticket.id))) ||
        (!!this.selectedTicket.length &&
          !this.selectedTicket.find(st => st.id.includes(ticket.id)) &&
          !selectableTickets.find(st => st.id === ticket.id))
      )
    },
  },
}
</script>
<style scoped>
p {
  margin-bottom: 0;
}
.tickets-container-title {
  background: #f5f5f5;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  padding: 16px 24px;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  border-radius: 8px 8px 0 0;
}

.ticket {
  width: 100%;
  background: #fff !important;
  cursor: pointer;
  height: fit-content !important;
  border: 1px solid #d9d9d9;
  align-items: center;
  border-radius: 1000px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 10px;
  box-shadow: none !important;
}

.ticket:disabled {
  cursor: default;
  opacity: 0.35;
}

.ticket-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
}

.ticket-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
}

.ticket-action-icon {
  width: 25px;
  height: 24px;
  border-radius: 999px;
  background: #e7f2fa;
  color: #0277bd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.ticket--selected .ticket-action-icon {
  width: auto;
  height: auto;
  background: transparent;
  color: #fff;
  font-size: 20px;
}

.ticket--selected .ticket-count {
  background: #fff !important;
  color: #0277bd;
}

.ticket-connected {
  color: #fff;
  font-family: 'Source Sans Pro';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}

.seat-state {
  width: fit-content;
  min-height: 1.7rem;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  border-radius: 1000px;
  align-items: center;
  display: flex;
  gap: 4px;
  padding: 4px 8px !important;
  box-shadow: none !important;
}

.ticket-name {
  overflow: hidden;
color: #666;
text-overflow: ellipsis;
font-family: 'Source Sans Pro';
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 150%;
  white-space: nowrap;
}

.tickets-wrapper {
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
}

.hr-style {
  height: 1px;
  background: #d9d9d9;
  border-radius: 2px;
}

v-btn >>> .v-btn__content {
  display: flex;
  flex-direction: column;
}

.seat-state-wrapper {
  display: flex;
  gap: 0.5rem;
}

.ticket-color {
  width: 12px;
  height: 12px;
  border-radius: 1000px;
  flex: 0 0 auto;
}
@media screen and (max-width: 1331px) {
  .tickets-container {
    max-width: 42.75rem !important;
    margin-top: 1.5rem;
  }
}

.unavailable-circle {
  display: inline-block;
  margin-left: 0.5rem;
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 62.5rem;
  background: #d9d9d9;
}

.ticket-type {
  color: #666;
  font-family: 'Raleway';
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 1rem;
}

.tickets-container {
  max-width: 24.125rem;
  min-height: 16.0625rem;
  border: #d9d9d9 solid 1px;
  border-radius: 8px;
}
.booked-sold-circle {
  display: inline-block;
  margin-left: 0.5rem;
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 62.5rem;
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
}
.ticket-price {
  margin-right: 8px;
  color: #9e9e9e;
}
.ticket-count {
  height: 18px;
  min-width: 18px;
  border-radius: 2px;
background: #F0F6FA;
color: #0277BD;
font-family: 'Source Sans Pro';
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 150%;
  padding: 0 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
